// extracted by mini-css-extract-plugin
module.exports = {"tpbLogo":"ThePrivateBankLogo__tpbLogo___Tehu4","desktop":"ThePrivateBankLogo__desktop___1zt6F","mobile":"ThePrivateBankLogo__mobile___3yp_N"};